import { JSONSchema7Array, JSONSchema7Object } from 'json-schema';
import { VFC } from 'react';

import Accordion from 'dashboard/components/Accordion';
import { WorkflowActionRunHttpPlatformIntegrationV1Output as Output } from 'dashboard/models/workflow-version';
import Attribute, { AttributeGrid } from 'design-system/components/Attribute';
import Spacer from 'design-system/components/Spacer';
import Sticker from 'design-system/components/Sticker';

const flattenObject = (
  data: JSONSchema7Object | JSONSchema7Array,
  parentKey = '',
): Record<string, string> => {
  const flattened: Record<string, string> = {};

  const flatten = (obj: JSONSchema7Object | JSONSchema7Array, prefix = '') => {
    Object.entries(obj).forEach(([key, value]) => {
      const newKey = prefix ? `${prefix}.${key}` : key;
      if (typeof value === 'object' && !(value == null)) {
        flatten(value, newKey);
      } else {
        flattened[newKey] = String(value);
      }
    });
  };

  flatten(data, parentKey);
  return flattened;
};

const DisplayFormData: VFC<{
  formData: JSONSchema7Object;
}> = ({ formData }) => {
  const flattenedData = flattenObject(formData);
  return (
    <AttributeGrid>
      {Object.entries(flattenedData).map(([key, value]) => (
        <Attribute key={key} label={key} value={value} />
      ))}
    </AttributeGrid>
  );
};

const ActionOutputRunHttpPlatformIntegrationV1: VFC<{ output: Output }> = ({ output }) => {
  const { request, response, 'response-status': responseStatus } = output;

  return (
    <>
      <Accordion title='Request' defaultExpanded={false}>
        <Spacer height={2} />
        <DisplayFormData formData={request.body} />
      </Accordion>
      <Spacer height={2} />
      <Accordion
        title={
          <>
            Response{' '}
            <Sticker>
              {responseStatus.code} ({responseStatus.reason})
            </Sticker>
          </>
        }
        defaultExpanded={false}
      >
        <Spacer height={2} />
        <DisplayFormData formData={response} />
      </Accordion>
    </>
  );
};

export default ActionOutputRunHttpPlatformIntegrationV1;
